module.exports = __webpack_public_path__ + "img/logo_60x60.5aac1645.png";